import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 画面再表示時の情報取得するサービス
 *
 * @export GetImageNameService
 * @class GetImageNameService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetImageNameService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof GetImageNameService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetImageNameService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageNameService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageNameService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetImageName', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageNameService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
